import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconFilters = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='20'
            viewBox='0 0 20 20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'>
            <g mask='url(#mask0_144_4728)'>
                <path
                    d='M9.7085 16.7904V12.207H10.7918V13.957H16.7918V15.0404H10.7918V16.7904H9.7085ZM3.2085 15.0404V13.957H7.79183V15.0404H3.2085ZM6.2085 12.2904V10.5404H3.2085V9.45703H6.2085V7.70703H7.29183V12.2904H6.2085ZM9.2085 10.5404V9.45703H16.7918V10.5404H9.2085ZM12.2085 7.79036V3.20703H13.2918V4.95703H16.7918V6.04036H13.2918V7.79036H12.2085ZM3.2085 6.04036V4.95703H10.7918V6.04036H3.2085Z'
                    fill={fill}/>
            </g>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconFilters;
